export class Tax {
  name!: string;
  percent!: string;
  group!: string;

  public load(data: any): Tax {

    Object.assign(this, data);

    return this;
  }
}
